/**
 * Did this request fail because the feature is switched off for the instance?
 *
 * The server answers a flagged-off Connectors surface with `404` and
 * `code: "FEATURE_NOT_ENABLED"` (see server/middleware/connectorsFlag.ts). The
 * client needs to tell that apart from an ordinary failure, because they call
 * for opposite treatments:
 *
 *   feature off    render NOTHING. There is no card, no page, no entry point.
 *   request failed render a message saying so, with a way to retry.
 *
 * Getting this backwards in either direction is a visible bug. Showing "Status
 * could not be read" to a customer who simply does not have the feature invites
 * a support ticket about a product they cannot buy; and silently hiding a card
 * because of a transient 500 tells an admin their connector vanished.
 *
 * Matched on the code rather than the status alone, so an unrelated 404 (a bad
 * id, a route that moved) still reads as a real failure.
 */
export function isFeatureDisabled(error: unknown): boolean {
  if (!error || typeof error !== "object") return false;
  const err = error as { status?: number; data?: { code?: string } };
  return err.status === 404 && err.data?.code === "FEATURE_NOT_ENABLED";
}
